import { render, staticRenderFns } from "./OptionRelationship.vue?vue&type=template&id=1d89105e&"
import script from "./OptionRelationship.vue?vue&type=script&lang=js&"
export * from "./OptionRelationship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports